import {
  APPROVE_OFF_PLATFORM_DOCS,
  APPROVE_VERIFICATION_REQUEST,
  GET_BANK_TRANSFER_VERIFICATION_REQUEST_DETAILS_REQUEST,
  GET_BANK_TRANSFER_VERIFICATION_REQUEST_DETAILS_RESPONSE,
  GET_OFFPLATFORM_VERIFICATION_REQUEST_DETAILS_REQUEST,
  GET_OFFPLATFORM_VERIFICATION_REQUEST_DETAILS_RESPONSE,
  GET_ONLINE_PAYMENT_VERIFICATION_REQUEST_DETAILS_REQUEST,
  GET_ONLINE_PAYMENT_VERIFICATION_REQUEST_DETAILS_RESPONSE,
  GET_VERIFICATIONS_REQUESTS_LIST_REQUEST,
  GET_VERIFICATIONS_REQUESTS_LIST_RESPONSE,
  GET_VERIFICATION_REQUEST_MAIN_INFO,
  REJECT_VERIFICATION_REQUEST,
  REQUEST_EDIT_OFF_PLATFORM_DOCS,
  SEND_REQUIRED_VERIFICATION_DOCUMENTS_REQUEST
} from "./types";

export const getVerificationsRequestsListRequest = (payload) => ({
  type: GET_VERIFICATIONS_REQUESTS_LIST_REQUEST,
  payload
});

export const getVerificationsRequestsListResponse = (payload) => ({
  type: GET_VERIFICATIONS_REQUESTS_LIST_RESPONSE,
  payload
});

export const getVerificationsRequestMainInfo = (payload) => ({
  type: GET_VERIFICATION_REQUEST_MAIN_INFO,
  payload
});

export const getOffPlatformVerificationsRequestDetailsRequest = (
  payload
) => ({
  type: GET_OFFPLATFORM_VERIFICATION_REQUEST_DETAILS_REQUEST,
  payload
});

export const getOffPlatformVerificationsRequestDetailsResponse = (
  payload
) => ({
  type: GET_OFFPLATFORM_VERIFICATION_REQUEST_DETAILS_RESPONSE,
  payload
});

export const getOnlinePaymentVerificationsRequestDetailsRequest = (
  payload
) => ({
  type: GET_ONLINE_PAYMENT_VERIFICATION_REQUEST_DETAILS_REQUEST,
  payload
});

export const getOnlinePaymentVerificationsRequestDetailsResponse = (
  payload
) => ({
  type: GET_ONLINE_PAYMENT_VERIFICATION_REQUEST_DETAILS_RESPONSE,
  payload
});

export const getBankTransferVerificationsRequestDetailsRequest = (
  payload
) => ({
  type: GET_BANK_TRANSFER_VERIFICATION_REQUEST_DETAILS_REQUEST,
  payload
});

export const getBankTransferVerificationsRequestDetailsResponse = (
  payload
) => ({
  type: GET_BANK_TRANSFER_VERIFICATION_REQUEST_DETAILS_RESPONSE,
  payload
});

export const sendRequiredVerificationDocumentsRequest = (
  payload
) => ({
  type: SEND_REQUIRED_VERIFICATION_DOCUMENTS_REQUEST,
  payload
});

export const approveOffPlatformDocs = (payload) => ({
  type: APPROVE_OFF_PLATFORM_DOCS,
  payload
});

export const requestEditOffPlatformDocs = (payload) => ({
  type: REQUEST_EDIT_OFF_PLATFORM_DOCS,
  payload
});

export const approveVerificationRequest = (payload) => ({
  type: APPROVE_VERIFICATION_REQUEST,
  payload
});

export const rejectVerificationRequest = (payload) => ({
  type: REJECT_VERIFICATION_REQUEST,
  payload
});
